import {
  ApolloClient,
} from '@apollo/client';
import {
  V2Gateway_GetBookingCartByUidDocument,
  V2Gateway_GetBookingCartByUidQuery,
  V2Gateway_GetBookingCartByUidQueryResult,
  V2Gateway_GetBookingCartByUidQueryVariables,
} from 'Generated/graphql';
import { AppCookie } from './Cookie';

export type GetBookingCartByUid =
  NonNullable<
    V2Gateway_GetBookingCartByUidQueryResult['data']
  >['getBookingCartByUID']

const getBookingCartByUid = async (
  queryFn: ApolloClient<object>['query'],
  sessionJwt: string | undefined,
  bookingCartUid: string,
) => {
  const res =
    await queryFn<
      V2Gateway_GetBookingCartByUidQuery | null,
      V2Gateway_GetBookingCartByUidQueryVariables
    >({
      query: V2Gateway_GetBookingCartByUidDocument,
      context: sessionJwt ? {
        headers: {
          cookie: `${AppCookie.PeazySession}=${sessionJwt}`,
        }
      } : undefined,
      variables: {
        uid: bookingCartUid,
      },
      fetchPolicy: 'no-cache',
    });

  return res?.data?.getBookingCartByUID;
};

export default getBookingCartByUid;

